// extracted by mini-css-extract-plugin
module.exports = {"Text":"ProfessionalExperience__Text_OlLt0"};